var map = {
	"./condo-icon.svg": "4418",
	"./edit-icon.svg": "f4c4",
	"./ee-icon.svg": "8275",
	"./factory-icon.svg": "a351",
	"./gas-icon.svg": "9653",
	"./home-icon.svg": "8f3c",
	"./hotel-icon.svg": "289a",
	"./info-icon.svg": "2656",
	"./office-icon.svg": "94d6",
	"./store-icon.svg": "7e00",
	"./tap-icon.svg": "70bb",
	"./user-icon.svg": "149a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";